<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-school_bk.png" alt width="27.3" height="27.3" />
      <p class="title-bk">映像視聴ID</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'school-id-video-viewing', params: { id: schoolId } }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">映像視聴ID名：</th>
                <td />
                <td>{{ currentVideoViewingPole.nameReading }}（{{ currentVideoViewingPole.uid }}）</td>
              </tr>
              <StudentPasswordField vid="password" v-model="password" extraRules="required" />
              <StudentPasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="映像視聴ID情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>映像視聴ID情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import StudentPasswordField from '@/components/forms/StudentPasswordField.vue';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    schoolId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('video_viewing_pole/fetchVideoViewingPole', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    ValidationObserver,
    StudentPasswordField,
    PopUpHolder,
  },
  computed: {
    currentVideoViewingPole() {
      return this.video_viewing_pole.videoViewingPole;
    },
    ...mapState(['video_viewing_pole']),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentVideoViewingPole.id,
        password: this.password,
      };
      this.changeVideoViewingPolePassword(payload).then(() => {
        this.$logger.debug('Password Changed for ID: ' + this.id + ', show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'school-id-video-viewing', params: { id: this.schoolId } });
    },
    ...mapActions('video_viewing_pole', ['changeVideoViewingPolePassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.line-break {
  width: 100%;
}
</style>
